import { fmtDateIST } from "@/lib/dates";
import { Check, Truck, PackageCheck, Undo2, Package } from "lucide-react";

const ICONS = {
  "Picked Up": Package,
  "In Transit": Truck,
  "Delivered": PackageCheck,
  "Returned to Client": Undo2,
};

const COLORS = {
  "Picked Up": "bg-blue-600",
  "In Transit": "bg-orange-500",
  "Delivered": "bg-green-600",
  "Returned to Client": "bg-red-600",
};

export default function OrderTimeline({ history = [], currentStatus }) {
  const flow = currentStatus === "Returned to Client"
    ? ["Picked Up", "In Transit", "Returned to Client"]
    : ["Picked Up", "In Transit", "Delivered"];

  const entryFor = (s) => history.find((h) => h.status === s);

  return (
    <div className="flex items-start w-full" data-testid="order-timeline">
      {flow.map((step, i) => {
        const entry = entryFor(step);
        const done = Boolean(entry);
        const Icon = ICONS[step];
        return (
          <div key={step} className="flex-1 flex items-start">
            <div className="flex flex-col items-center text-center min-w-[90px]">
              <div
                className={`h-10 w-10 rounded-full flex items-center justify-center border-2 transition-colors duration-150 ${
                  done ? `${COLORS[step]} border-transparent text-white` : "bg-white border-slate-300 text-slate-300"
                }`}
                data-testid={`timeline-node-${step.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {done ? <Check className="h-5 w-5" /> : <Icon className="h-5 w-5" />}
              </div>
              <div className={`mt-2 text-xs font-semibold ${done ? "text-slate-900" : "text-slate-400"}`}>{step}</div>
              {entry && (
                <div className="mt-0.5 text-[11px] text-slate-500 tnum leading-snug">
                  {fmtDateIST(entry.at)} · {entry.by_name}
                </div>
              )}
            </div>
            {i < flow.length - 1 && (
              <div className={`flex-1 h-0.5 mt-5 mx-1 ${entryFor(flow[i + 1]) ? COLORS[flow[i + 1]] : "bg-slate-200"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
